import Joi from "joi";

export const ValidadeTaxService = (data) => {
  const schema = Joi.object({
    descricao: Joi.string().required().messages({
      "string.empty": "(Descrição) deve ser informado!",
      "any.required": "(Descrição) deve ser informado!"
    }),
    refObject: Joi.object({
      codigo_servico: Joi.string().required().messages({
        "string.empty": "(Cód. do Serviço) deve ser informado!",
        "any.required": "(Cód. do Serviço) deve ser informado!"
      }),
     })
  })

  const { error } = schema.validate(data, {
    allowUnknown: true,
  })

  if (error?.details[0]?.message || error?.details[0]?.path[0]) {
    if(error?.details[0].path.length > 1) {
      return {
        message: error?.details[0]?.message,
        keyError: error?.details[0]?.path[1]
      }
    }
    
    return {
      message: error?.details[0]?.message,
      keyError: error?.details[0]?.path[0]
    }
  }
}